module.exports = __webpack_public_path__ + "img/wex.a3d274c1.svg";